import { IntlShape, useIntl } from 'react-intl';
import { IconInfoSquareRounded } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip, Typography } from '@rossum/ui/material';
import { LocalizationKeys } from '../../../../../i18n';

type Props = {
  titleId: LocalizationKeys;
  tooltipId?: LocalizationKeys;
  tooltipValues?: Parameters<IntlShape['formatMessage']>['1'];
};

const QueueSettingsLabel = ({ titleId, tooltipId, tooltipValues }: Props) => {
  const intl = useIntl();
  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Typography>{intl.formatMessage({ id: titleId })}</Typography>
      {tooltipId && (
        <Tooltip
          placement="top"
          title={intl.formatMessage({ id: tooltipId }, tooltipValues) ?? ''}
        >
          <SvgIcon fontSize="large" color="action">
            <IconInfoSquareRounded />
          </SvgIcon>
        </Tooltip>
      )}
    </Stack>
  );
};

export default QueueSettingsLabel;
